import { handlePromise } from "~lib/helpers";
import { sdk } from "~lib";
import { useOrganization } from "~hooks";
import { useRouter } from "next/router";

export default function useGoToRelease(eventId: string) {
  const { organization } = useOrganization();
  const router = useRouter();
  const cartRecovery = !!router.query.cartRecovery;

  const gotToRelease = async () => {
    const inputElement = document.getElementById(
      "reservationInput"
    ) as HTMLInputElement;

    const code = inputElement.value?.trim();
    if (!code) {
      return;
    }

    const { data: release } = await handlePromise(async () =>
      sdk({ orgId: organization?.id }).validateReleasePasswordOrRelease({
        eventId,
        password: code,
      })
    );

    void router.push({
      pathname: `/${eventId}/releases/${encodeURIComponent(
        release?.validateReleasePasswordOrRelease.slug
      )}`,
      query: {
        code: release?.validateReleasePasswordOrRelease?.password
          ? undefined
          : code,
        ...(cartRecovery ? { cartRecovery: "true" } : {}),
      },
    });
  };

  return gotToRelease;
}
